import { Stack, TextField, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setIngredientInput,
  setIngredientError,
  clearIngredientInput,
} from "../ingredientsInputSlice";
import { addIngredient } from "../../ingredientsList/ingredientsListSlice";

const IngredientInput = () => {
  const dispatch = useDispatch();
  const { input, error } = useSelector((state) => state.ingredientsInput);
  const { ingredients } = useSelector((state) => state.ingredientsList);

  const isValidFormat = (text) => /^[a-zA-Z\s-]+$/.test(text.trim());

  const handleAdd = async () => {
    const trimmed = input.trim();
    if (!trimmed || !isValidFormat(trimmed)) {
      dispatch(
        setIngredientError(
          "Invalid input: input can only contain letters, spaces, and hyphens"
        )
      );
      return;
    }

    if (ingredients.includes(trimmed.toLowerCase())) {
      dispatch(setIngredientError("Ingredient already exists"));
      return;
    }

    dispatch(addIngredient(trimmed));
    dispatch(clearIngredientInput());
    dispatch(setIngredientError(""));
  };

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      sx={{ mb: 3, alignItems: { sm: "flex-start" } }}
    >
      <TextField
        label="Add Ingredient"
        value={input}
        onChange={(e) => {
          dispatch(setIngredientInput(e.target.value));
          dispatch(setIngredientError(""));
        }}
        error={!!error}
        helperText={error}
        fullWidth
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 4,
            backgroundColor: "rgba(255,255,255,0.9)",
            "& fieldset": {
              borderColor: "rgba(249,115,22,0.22)",
            },
            "&:hover fieldset": {
              borderColor: "primary.main",
            },
            "&.Mui-focused fieldset": {
              borderWidth: 2,
              borderColor: "secondary.main",
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "secondary.dark",
          },
        }}
      />
      <Button
        variant="contained"
        onClick={handleAdd}
        sx={{
          minWidth: { xs: "100%", sm: 120 },
          py: 1.7,
          borderRadius: 2,
          background: "linear-gradient(135deg, #0ea5e9, #38bdf8)",
          boxShadow: "0 14px 28px rgba(14, 165, 233, 0.22)",
          "&:hover": {
            background: "linear-gradient(135deg, #0284c7, #0ea5e9)",
          },
        }}
      >
        Add
      </Button>
    </Stack>
  );
};

export default IngredientInput;
